import { collectAttribution } from './attribution';

/**
 * Flat signup attribution for users.signupAttribution (server-protected after create).
 */
export function buildSignupAttribution(passedAttribution) {
  const attr = passedAttribution || collectAttribution();
  const at = new Date().toISOString();
  if (!attr) {
    return {
      utmSource: null,
      utmMedium: null,
      utmCampaign: null,
      gclid: null,
      fbclid: null,
      referrer: typeof document !== 'undefined' ? document.referrer || null : null,
      landingPage: typeof window !== 'undefined' ? window.location.href : null,
      at,
    };
  }
  const utms = attr.utms || {};
  const clickIds = attr.clickIds || {};
  return {
    utmSource: utms.utm_source || null,
    utmMedium: utms.utm_medium || null,
    utmCampaign: utms.utm_campaign || null,
    gclid: clickIds.gclid || null,
    fbclid: clickIds.fbclid || null,
    referrer: attr.referrer || null,
    landingPage: attr.landingUrl || null,
    at,
  };
}

/** Prefill onboarding URL from business email domain (skip free-mail). */
const FREE_MAIL = new Set([
  'gmail.com', 'googlemail.com', 'yahoo.com', 'hotmail.com', 'outlook.com',
  'live.com', 'icloud.com', 'aol.com', 'proton.me', 'protonmail.com',
]);

export function websiteFromEmail(email) {
  if (!email || !email.includes('@')) return '';
  const domain = email.split('@')[1]?.trim().toLowerCase();
  if (!domain || FREE_MAIL.has(domain)) return '';
  return `https://${domain}`;
}
